import Button from '@mui/material/Button';
import React, { useEffect } from 'react';
import { useReviewPostContext } from '@view/flagged-posts/hooks/useReviewPosts';

export const FlagReviewButton: React.FC<{
  setSubmitting: (submitting: boolean) => void;
  show?: boolean;
}> = ({ setSubmitting, show }) => {
  const { submitting, reviews, reset, onSubmit } = useReviewPostContext();

  useEffect(() => {
    setSubmitting(submitting);
  }, [submitting, setSubmitting]);

  return (
    <Button
      disabled={reviews.length === 0}
      className={`mb-5 mt-5 w-[220px] h-[50px] ${!show ? 'invisible' : ''}`}
      color="primary"
      variant="contained"
      onClick={onSubmit()}
    >
      Submit Review
    </Button>
  );
};
